import React from 'react';
import { useTranslation } from 'react-i18next';
import StorefrontLayout from '../components/layout/StorefrontLayout';
import {
  acceptAllCookies,
  readCookiePreferences,
  rejectNonEssentialCookies,
  saveCookiePreferences,
} from '../utils/cookiePreferences';

export default function CookieSettingsPage() {
  const { t } = useTranslation();
  const current = readCookiePreferences();
  const [analytics, setAnalytics] = React.useState(Boolean(current?.analytics));
  const [personalization, setPersonalization] = React.useState(Boolean(current?.personalization));
  const [marketing, setMarketing] = React.useState(Boolean(current?.marketing));
  const [saved, setSaved] = React.useState(false);

  const onSave = () => {
    saveCookiePreferences({ analytics, personalization, marketing });
    setSaved(true);
    window.setTimeout(() => setSaved(false), 1600);
  };

  return (
    <StorefrontLayout contentContained>
      <section className="py-4">
        <h1 className="text-3xl font-bold text-slate-900">{t('public.cookie_page_title')}</h1>
        <p className="mt-2 text-sm text-slate-600">{t('public.cookie_page_intro')}</p>
        <div className="mt-5 max-w-2xl space-y-3 rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
          <label className="flex items-start justify-between gap-3 rounded-lg border border-slate-200 p-3 text-sm">
            <span>
              <span className="block font-semibold text-slate-900">{t('public.cookie_essential_title')}</span>
              <span className="block text-xs text-slate-600">{t('public.cookie_essential_desc')}</span>
            </span>
            <input type="checkbox" checked disabled className="mt-1" />
          </label>
          <label className="flex items-start justify-between gap-3 rounded-lg border border-slate-200 p-3 text-sm">
            <span>
              <span className="block font-semibold text-slate-900">{t('public.cookie_analytics_title')}</span>
              <span className="block text-xs text-slate-600">{t('public.cookie_analytics_desc')}</span>
            </span>
            <input type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} className="mt-1" />
          </label>
          <label className="flex items-start justify-between gap-3 rounded-lg border border-slate-200 p-3 text-sm">
            <span>
              <span className="block font-semibold text-slate-900">{t('public.cookie_personalization_title')}</span>
              <span className="block text-xs text-slate-600">{t('public.cookie_personalization_desc')}</span>
            </span>
            <input type="checkbox" checked={personalization} onChange={(e) => setPersonalization(e.target.checked)} className="mt-1" />
          </label>
          <label className="flex items-start justify-between gap-3 rounded-lg border border-slate-200 p-3 text-sm">
            <span>
              <span className="block font-semibold text-slate-900">{t('public.cookie_marketing_title')}</span>
              <span className="block text-xs text-slate-600">{t('public.cookie_marketing_desc')}</span>
            </span>
            <input type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} className="mt-1" />
          </label>
          <div className="flex flex-wrap gap-2">
            <button type="button" onClick={onSave} className="rounded-lg bg-slate-900 px-4 py-2 text-sm font-semibold text-white">
              {t('public.cookie_save')}
            </button>
            <button
              type="button"
              onClick={() => {
                acceptAllCookies();
                setAnalytics(true);
                setPersonalization(true);
                setMarketing(true);
                setSaved(true);
              }}
              className="rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-800"
            >
              {t('public.cookie_accept_all')}
            </button>
            <button
              type="button"
              onClick={() => {
                rejectNonEssentialCookies();
                setAnalytics(false);
                setPersonalization(false);
                setMarketing(false);
                setSaved(true);
              }}
              className="rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-800"
            >
              {t('public.cookie_reject')}
            </button>
          </div>
          {saved ? <p className="text-xs font-medium text-emerald-700">{t('public.cookie_saved')}</p> : null}
        </div>
      </section>
    </StorefrontLayout>
  );
}
